import React from 'react'
import "./TeamCard.css";
function TeamCard({
  name,
  designation,
  creds,
  email,
  linkedin,
  img,
  bio,
}) {
  return (
    <>
      <div className="teamcard">
        <div className="img-container">
          <img src={img} alt={name} />
        </div>
        <h1>{name}</h1>
        <p className="designation">{designation}</p>
        <p className="bio">{creds || bio}</p> {/* Fallback to bio if creds not present, or use bio as primary */}

        {/* Hidden contact links for clean design - simplified */}
        {/* 
        <div className="social-links">
             <a href={linkedin}>LinkedIn</a>
        </div> 
        */}
      </div>
    </>
  );
}

export default TeamCard
